/**
 * Split full name en first/last
 * Utilisé par le composant full-name-input
 */

export function splitFullName(fullName) {
  const parts = fullName.trim().split(/\s+/);

  if (parts.length === 1) {
    return { first: parts[0], last: null };
  }

  return {
    first: parts[0],
    last: parts.slice(1).join(' ')
  };
}

/**
 * Initialise le composant full-name-input
 */
export function initFullNameInput() {
  const fullNameInput = document.querySelector('[name="full_name"]');
  const firstNameInput = document.querySelector('[data-first-name]');
  const lastNameInput = document.querySelector('[data-last-name]');

  if (!fullNameInput || !firstNameInput || !lastNameInput) return;

  // Mettre à jour les champs cachés lors de la saisie
  fullNameInput.addEventListener('input', function() {
    const { first, last } = splitFullName(this.value);
    firstNameInput.value = first || '';
    lastNameInput.value = last || '';
  });

  // Au cas où il y a une valeur initiale
  if (fullNameInput.value) {
    const { first, last } = splitFullName(fullNameInput.value);
    firstNameInput.value = first || '';
    lastNameInput.value = last || '';
  }
}
